import type { ButtonHTMLAttributes, ReactNode } from "react";
import styles from "./ds.module.css";

type Variant = "primary" | "secondary" | "outline" | "ghost";
const VARIANT: Record<Variant, string> = {
    primary: styles.btnPrimary, secondary: styles.btnSecondary, outline: styles.btnOutline, ghost: styles.btnGhost,
};

/** Buttons are verbs, one or two words. Destructive actions never get a solid red fill. */
export function Button({ variant = "primary", size = "md", icon, children, className, type = "button", ...rest }:
    ButtonHTMLAttributes<HTMLButtonElement> & { variant?: Variant; size?: "sm" | "md"; icon?: ReactNode }) {
    return (
        <button type={type} className={`${styles.btn} ${size === "sm" ? styles.btnSm : styles.btnMd} ${VARIANT[variant]} ${className ?? ""}`} {...rest}>
            {icon}{children}
        </button>
    );
}

/** The bordered square that carries a small action: previous page, next page, close. */
export function IconButton({ label, size = 26, children, type = "button", ...rest }:
    ButtonHTMLAttributes<HTMLButtonElement> & { label: string; size?: number }) {
    return (
        <button type={type} aria-label={label} title={label} className={styles.iconBtn} style={{ width: size, height: size }} {...rest}>
            {children}
        </button>
    );
}

export function LinkButton({ children, type = "button", className, ...rest }: ButtonHTMLAttributes<HTMLButtonElement>) {
    return <button type={type} className={`${styles.btnLink} ${className ?? ""}`} {...rest}>{children}</button>;
}
